module.exports = __webpack_public_path__ + "img/Rabey-logo-w.355616c9.png";